
const selectNamesakes = (state) => {
    return state.namesakes.all;
};


export default { selectNamesakes };